import React, { FC } from 'react';
import { Paper, Typography } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { LineChart, Line, ResponsiveContainer, Tooltip, TooltipProps } from 'recharts';
import moment from 'moment';

import { TrendingData } from 'api';
import { TextTransform } from 'components';

import { LINE_CHART_HEIGHT } from '../../constants';

interface Props {
  data: TrendingData[];
  config: {
    dataKey: string;
    label: string;
  };
}

const useStyles = makeStyles(theme => ({
  tooltip: {
    padding: theme.spacing(1),
  },
}));

const CustomTooltip: FC<TooltipProps<number, string>> = ({ active, payload }) => {
  const classes = useStyles();

  if (!active || !payload?.length) {
    return null;
  }

  const [currentPayload] = payload;
  const { name, value } = currentPayload;
  const date = moment(currentPayload.payload.calendar_day).format('ll');

  return (
    <Paper className={classes.tooltip}>
      <Typography>{date}</Typography>
      <Typography>
        <TextTransform transform="capitalize">{name}</TextTransform>: {value}
      </Typography>
    </Paper>
  );
};

const ActivityLineChart: FC<Props> = ({ data, config }) => {
  const theme = useTheme();

  return (
    <ResponsiveContainer height={LINE_CHART_HEIGHT}>
      <LineChart data={data}>
        <Line
          type="monotone"
          dataKey={config.dataKey}
          stroke={theme.palette.primary.main}
          strokeWidth={2}
          dot={false}
        />
        <Tooltip content={<CustomTooltip />} />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default ActivityLineChart;
